export default class marca{
	constructor($scope,
				$routeParams,
				method,
				marcasService,
				$location,
                $uibModal,
				toastr
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
        this.modal = $uibModal;
		switch (method) {
			case 'list':
				this.list(marcasService);
			break;
			case 'new':
				this.create(marcasService);
			break;
			case 'view':
				this.view($routeParams,
                    marcasService);
			break;
		}
	}

	list(marcasService){
        let self = this.scope;

        marcasService.getAll().then((resp, err) => {
			this.scope.marcas = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.marcas.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, marcasService);
        /*
        this.scope.inAction = false;
		this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                marcasService.delete({_id: id}).then((resp) => {
                    if (resp.data.success == true) {
                        this.toastr.success('Marca eliminada correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        window.location.reload();
                    }
                })
				.catch((err) => {
                    this.scope.inAction = false;
					this.toastr.error('Error', 'Error al eliminar la marca!', {
						timeOut: 2000,
						closeButton: true
					});
				});
            }
		};*/
	}

	create(marcasService){

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction && this.scope.marca.grupo != null) {
                this.scope.inAction = true;
                marcasService.save(this.scope.marca).then((resp) => {
                    this.toastr.success('Marca creada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/marca');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al crear la marca!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

	view($routeParams,
         marcasService){

		this.scope.aux = {};
        marcasService.getById({_id: $routeParams.id}).then((resp) => {
			this.scope.marca = resp.data.message;
		}).catch((er) => {
			console.log(er);
		});

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction && this.scope.marca.grupo != null) {
                this.scope.inAction = true;
                marcasService.update(this.scope.marca).then((resp) => {
                    this.toastr.success('Marca modificada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/marca');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar la marca!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Marca</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar la marca: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.marcas.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Marca eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar la marca!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/marca/marca.js